import { Check, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PasswordRequirementsProps {
  password: string;
}

const requirements = [
  { label: '8+ characters', test: (pw: string) => pw.length >= 8 },
  { label: 'Lowercase letter', test: (pw: string) => /[a-z]/.test(pw) },
  { label: 'Uppercase letter', test: (pw: string) => /[A-Z]/.test(pw) },
  { label: 'Digit', test: (pw: string) => /[0-9]/.test(pw) },
  { label: 'Symbol', test: (pw: string) => /[^a-zA-Z0-9]/.test(pw) },
];

export const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-2">
      {requirements.map((req) => {
        const met = password ? req.test(password) : false;
        return (
          <div key={req.label} className="flex items-center gap-1.5">
            {met ? (
              <Check className="w-3.5 h-3.5 text-emerald-500" />
            ) : (
              <X className="w-3.5 h-3.5 text-muted-foreground/50" />
            )}
            <span
              className={cn(
                'text-xs transition-colors',
                met ? 'text-emerald-500' : 'text-muted-foreground'
              )}
            >
              {req.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};
